<p-table [value]="pagesScannedData" [style]="{ width: '100%' }" stripedRows>
  <ng-template pTemplate="header">
    <tr><th><h2 class="text-xl">Pages Scanned</h2></th></tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData>
    <tr>
      <td>
        {{ rowData }}
        <a href="{{rowData}}" target="_blank" rel="noopener"
           title="Link to Page" [style]="{'display':'inline-block','marginLeft': '10px', 'fontSize': '12px'}">
          <i class="pi pi-external-link" [style]="{'fontSize': '12px'}"></i>
        </a>
      </td>
    </tr>
  </ng-template>
</p-table>
